import { ADMIN_API_BASE } from '../../callApi'
import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

export const collection = 'systemAdministratorDemotion'

export const schema = new schemas.Entity(collection)

type SystemAdministratorDemotion = {
  userId: string
}

export const remove =
  (callApi: CallApi) =>
  (_: unknown, { userId }: SystemAdministratorDemotion) => {
    return callApi(`${ADMIN_API_BASE}/users/${userId}/system-admin`, schema, {
      method: 'DELETE',
    })
  }
